var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('div',{style:(_vm.paddingBottom)}),_c('img',{staticClass:"absolute left-0 top-0 w-full h-full object-cover",attrs:{"src":_vm.pathToImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }